"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiGetUrl = void 0;
const utils_1 = require("@loadsure/utils");
function getApiGetUrl(path, apiToken, partnerId, aliasToken = "t") {
    const query = {
        [aliasToken]: apiToken
    };
    if (partnerId) {
        query.p = partnerId;
    }
    return utils_1.getPathWithQuery(path, query);
}
exports.getApiGetUrl = getApiGetUrl;
//# sourceMappingURL=index.js.map